import { Eyebrow, Section } from "@/ds";
import { contactRows, contactSection } from "@/content/portfolio";

export function Contact() {
  return (
    <Section id="contact" className="scroll-mt-[var(--header-h)]">
      <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)] gap-7 items-end">
        <div>
          <Eyebrow className="mb-5">{contactSection.eyebrow}</Eyebrow>
          <h2 className="font-display font-regular text-display-2 max-w-[18ch] mb-5">{contactSection.headline}</h2>
          <p className="max-w-[52ch] text-body text-text-body">{contactSection.body}</p>
        </div>

        <div className="flex flex-col gap-[28px]">
          {contactRows.map((row) => (
            <div key={row.label} className="flex flex-col gap-[6px] border-t border-border-hairline pt-[14px]">
              <span className="font-label text-label uppercase text-text-muted">{row.label}</span>
              {row.href ? (
                <a
                  href={row.href}
                  className="text-body-lg text-text-primary hover:text-signal-500"
                  {...(row.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                >
                  {row.value}
                </a>
              ) : (
                <span className="text-body-lg">{row.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
